import { atom } from "recoil";

const checkPwState = atom({
  key: "checkPwState",
  default: false,
});

const questionPageIndexState = atom({
  key: "questionPageIndexState",
  default: 1,
});

const selectIndex = atom({
  key: "selectIndex",
  default: { first: 0, second: 0 },
});

export { checkPwState, selectIndex, questionPageIndexState };
